import { useRentalManagerUserPropertyCloneWebApiHandler_clone } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

const useCloneListing = () =>
  useRentalManagerUserPropertyCloneWebApiHandler_clone({
    meta: {
      context: {
        api: 'rental-manager',
        details: 'useRentalManagerUserPropertyCloneWebApiHandler_clone',
      },
      invalidates: ['users-properties-clone'],
    },
  });

export default useCloneListing;
